import React, { useState } from "react";
import { MainContainer } from "../Components/Elements";
import PagesNav from "../Components/PagesNav";
import { Offcanvas, Pagination, Table } from "react-bootstrap";
import SearchInput from "../Components/SearchInput";
import AddInput from "../Components/AddInput";
import TableBtns from "../Components/TableBtns";
import editBtn from "../assets/icons/PermissionEdit.png";
import deleteBtn from "../assets/icons/PermissionDelete.png";
import MainInput from "../Components/MainInput";
import UnitCategoryType from "../hooks/Units/UnitCategoryType";
import NoData from "../Components/NoData";
import Shimmer from "../Components/Shimmer";
import UploadImage from "../Components/UploadImage";

const Units = () => {
  const {  NavItems,
    setSearch,
    handleShow,
    show,
    handleClose,
    unitCategory,
    loading,
    handlePageChange,
    currentPage,
    totalPages,
    getPageNumbers,
    deleteCategoryLoading,
    deleteCategory,
    onSubmitEditCategory,
    handleclickEditCategory,
    showEditCategory,
    handleCloseEditCategory,
    setCategoryNameEnEdit,
    categoryNameEnEdit,
    setCategoryNameArEdit,
    categoryNameArEdit,
    categoryEditLoading,
    setCategoryEn,
    setCategoryAr,
    handleAddNewCategory,
    loadingAddCategory,
    handleImageChange,
    imageForEdit
  } = UnitCategoryType();

  return (
    <>
       <MainContainer>
        <div className="d-flex gap-3 mb-3 align-items-center justify-content-end">
            <SearchInput search={(e) => setSearch(e.target.value)} />
            <AddInput onClick={handleShow} />
        </div>
        <div  className="border-bottom pb-3">
              <Table hover className="text-center">
                <thead>
                  <tr>
                    <th className="bg-light">Category ( English )</th>
                    <th className="bg-light">Category ( Arabic )</th>
                    <th className="bg-light">Image</th>
                    <th className="bg-light">Actions</th>
                  </tr>
                </thead>
                <tbody>
        {loading ? (
          Array.from({ length: 3 }, (_, index) => (
            // <div key={index} className="row py-4">
              <Shimmer
              key={index}  type={"table"}
              colSpan={11}
              />
            // </div>
          ))
        ) : unitCategory.length === 0 ? (
          <NoData />
        ) : (
          unitCategory.map((category, index) => (

                  <tr key={index}>
                    <td >
                      {category?.nameEn}
                    </td>
                    <td >
                      {category?.nameAr}
                    </td>
                    <td >
                      <img alt="Category-image"  style={{
                          width: "75px",
                          height: "75px",
                          objectFit: "contain",
                        }} src={category?.image}/>
                    </td>
                    <td>
                    <TableBtns
                      onClickDelete={() => {
                        deleteCategory(category._id);
                      }}
                      deleteloading={deleteCategoryLoading[category._id]}
                      onClickEdit={() => {
                        handleclickEditCategory(category);
                      }}
                    />
                  </td>
                  </tr>  ))
        )}
                </tbody>
              </Table>
            
            </div>
        
        {unitCategory.length > 0 && (
          <div className="d-flex justify-content-center mt-3">
            <Pagination>
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {getPageNumbers().map((pageNumber) => (
                <Pagination.Item
                  linkClassName="bg-white text-black"
                  key={pageNumber}
                  active={pageNumber === currentPage}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        )}
      </MainContainer>
      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header className="pt-5" closeButton>
          <Offcanvas.Title>Create Category</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column justify-content-between">
          <form onSubmit={handleAddNewCategory} 
            className="d-flex flex-column justify-content-between h-100"
            >
            <div className="d-flex flex-column gap-3">
              <div>
                <MainInput
                  label={"Name*"}
                  onChange={(e) => {
                    setCategoryEn(e.target.value);
                  }}
                  placeholder={"Enter Name....."}
                  required={true}
                  type={"text"}
                />
                <MainInput
                  label={"*اسم"}
                  onChange={(e) => {
                    setCategoryAr(e.target.value);
                  }}
                  placeholder={"....ادخل الاسم"}
                  required={true}
                  type={"text"}
                  dir="rtl"
                />
              <UploadImage onChange={handleImageChange} />

              </div>
            
            </div>
            <div className="d-flex justify-content-center align-items-center pb-3">
              <button
                type="submit"
                disabled={loadingAddCategory}
                className="btn bg-white text-main shadow-lg w-75 py-2 fw-bold"
              >
                {loadingAddCategory ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas
        show={showEditCategory}
        onHide={handleCloseEditCategory}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="pt-3">Edit Category</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form
            className="d-flex flex-column justify-content-between h-100"
            onSubmit={onSubmitEditCategory}
          >
            <div>
              <MainInput
                label={"Name*"}
                onChange={(e) => {
                  setCategoryNameEnEdit(e.target.value);
                }}
                placeholder={"Enter Name....."}
                required={true}
                type={"text"}
                value={categoryNameEnEdit}
              />
              <MainInput
                label={"*اسم"}
                onChange={(e) => {
                  setCategoryNameArEdit(e.target.value);
                }}
                placeholder={"....ادخل الاسم"}
                required={true}
                type={"text"}
                dir="rtl"
                value={categoryNameArEdit}
              />
              <UploadImage onChange={handleImageChange} edit={imageForEdit}/>

            </div>
            <div className="d-flex justify-content-center align-items-center pb-3">
              <button
                type="submit"
                disabled={categoryEditLoading}
                className="btn bg-white text-main shadow-lg w-75 py-2 fw-bold"
              >
                {categoryEditLoading ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Units;
